import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <br></br>
    <br></br>
    <br></br>
    <br></br><br></br>
    <br></br>
    <br></br><br></br>
    <br></br>
    <br></br><br></br>
    <br></br>
    <br></br><br></br>
    <br></br>
    <br></br>
    <h2>{`Employment`}</h2>
    <br></br>
    <h4>{`Software Engineer Intern at Cisco`}</h4>
    <p><em parentName="p">{`June - September 2019`}</em></p>
    <p><img parentName="p" {...{
        "src": "photos/rsz_cisco.jpg",
        "alt": "Graduation Photo",
        "title": "Joshua Cheung"
      }}></img></p>
    <ul>
      <li parentName="ul">{`Developed and deployed an automation system that periodically detects inefficient virtual machines (VMs) and endpoints, and then fixes them. This system increased company testing procedure efficiency and is still being used today (Java)`}</li>
      <li parentName="ul">{`Created a dashboard that enables further optimization of VMs. The work involved understanding various statistics of VMs on Amazon Web Services, detecting anomalies, then parsing this info and displaying them in a user-friendly manner`}<br></br>
        <br></br></li>
    </ul>
    <h4>{`Programming Instructor at IDtech`}</h4>
    <p><em parentName="p">{`June - September 2018`}</em>{` `}{` `}{` `}<img parentName="p" {...{
        "src": "photos/rsz_1rsz_idtechlogo.jpg",
        "alt": "Graduation Photo",
        "title": "Joshua Cheung"
      }}></img></p>
    <ul>
      <li parentName="ul">{`Educated aspiring CS students with mid and advanced levels of Java, C++ and C
using informative and efficient teaching techniques`}</li>
      <li parentName="ul">{`Implemented new teaching content with example projects`}<br></br>
        <br></br></li>
    </ul>
    <h4>{`Customer Service Relations at Stanford`}</h4>
    <p><em parentName="p">{`June - September 2017`}</em>{` `}{` `}{` `}<img parentName="p" {...{
        "src": "photos/rsz_1rsz_stanfordgsb.jpg",
        "alt": "Graduation Photo",
        "title": "Joshua Cheung"
      }}></img></p>
    <ul>
      <li parentName="ul">{`Communicated effectively with students and prospects from different cultural backgrounds`}</li>
      <li parentName="ul">{`Evangelized various benefits of the GSB and achieved a zero rate of complaints throughout the
internship`}<br></br>
        <br></br></li>
    </ul>
    <h4>{`Advertising Representative at Paris Baguette`}</h4>
    <p><em parentName="p">{`June - September 2016`}</em>{` `}{` `}{` `}<img parentName="p" {...{
        "src": "photos/rsz_parislogo.jpg",
        "alt": "Graduation Photo",
        "title": "Joshua Cheung"
      }}></img></p>
    <ul>
      <li parentName="ul">{`Increased sales of confectionary products by building an in-store campaign around store products`}</li>
      <li parentName="ul">{`Optimally served multiple customers during daily peak hours by switching between barista, cashier, and serving options`}</li>
    </ul>
    <br></br>
    <br></br>
    <br></br>
    <br></br>
    <br></br>
    <h2>{`About`}</h2>
    <p>{`Favorite Quarantine Games: `}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://skribbl.io/"
        }}>{`skribbl.io`}</a>{`: an online pictionary game where the first person to guess the word being drawn wins! `}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://coup.thebrown.net/"
        }}>{`Coup`}</a>{`: Seize control of the government with deceit and skill`}</li>
    </ul>
    <p>{`Likes: Board games, video games, tennis, piano, Sam Kim (artist), and any type of noodles!`}</p>
    <p>{`Dislikes: Bleu cheese, jump scares, drop towers`}</p>
    <p><img parentName="p" {...{
        "src": "photos/rsz_2oakland.jpg",
        "alt": "Graduation Photo",
        "title": "Joshua Cheung"
      }}></img>{` `}{` `}{` `}{` `}{` `}<img parentName="p" {...{
        "src": "photos/rsz_core.jpg",
        "alt": "Graduation Photo",
        "title": "Joshua Cheung"
      }}></img>{` `}{` `}{` `}{` `}{` `}<img parentName="p" {...{
        "src": "photos/rsz_1band.jpg",
        "alt": "Graduation Photo",
        "title": "Joshua Cheung"
      }}></img></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      